export const FETCH_CONTRACTS = "Contracts.FETCH_CONTRACTS";
export const FETCH_CONTRACTS_SUCCESS = "Contracts.FETCH_CONTRACTS_SUCCESS";
export const FETCH_CONTRACTS_FAILURE = "Contracts.FETCH_CONTRACTS_FAILURE";
